<template>

</template>

<script>
export default {
    name: "InboxDetail"
}
</script>

<style scoped>

</style>
